import React, { FC } from 'react';
import { useAuthenticationContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useTranslationsContext } from '../../lib/translation';

const redirectUri = window.location.href.replace(window.location.search, '');

type Props = {
  children: React.ReactNode;
};

const ProfileLoginComponent: FC<Props> = ({ children }) => {
  const authenticated = useAuthenticationContext();
  const translations = useTranslationsContext();
  if (!authenticated) {
    return (
      <a
        className="nav__item nav__item--icon nav__item--icon--right nav__item--icon--always-show-label icon-sign-in"
        href={`/auth/login?redirecturi=${redirectUri}`}
      >
        {translations.generics.authentication.sign_in}
      </a>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
};

ProfileLoginComponent.displayName = 'ProfileLoginComponent';
export default ProfileLoginComponent;
